// The English table (ship 3): the same keys, kinds and placeholders as th.js — apps/tray/test/tables.test.js
// holds the two together. Units and part names stay as they are.
import { boxDims, HW } from '../doc.js';
const S = {
  title: "Compartment tray",
  view: {
    "2d": "Edit cells",
    "3d": "View 3D",
  },
  gCell: "Selected cell",
  gSize: "Tray size",
  gWalls: "Walls",
  gStack: "Stacking",
  selName: (col, row, c) => `Column ${col + 1} · cell ${row + 1} — ${c} mm`,
  colSize: "Column width",
  cellSize: "Cell depth",
  kinds: {
    auto: "Automatic",
    "1/2": "1/2",
    "1/3": "1/3",
    "2/3": "2/3",
    mm: "Set mm",
  },
  split: "Split",
  addCol: "Add column",
  del: "Delete",
  w: "Width (mm)",
  d: "Depth (mm)",
  bed: "Print bed (mm)",
  bedOption: (w, d) => `${w} × ${d}`,
  bedWarn: (w, d) => `The tray is larger than the ${w} × ${d} mm print bed — it may not print in one piece`,
  wall: "Wall thickness",
  fillet: "Corner radius",
  divider: "Divider height",
  stackable: "Stackable (locking rims top and bottom)",
  clearance: "Stack clearance",
  stackNote: (h) => `Stack of 3: ${Math.round((3 * (h - 1) + 1) * 10) / 10} mm tall · each further tray adds ${Math.round((h - 1) * 10) / 10} mm`,
  size: (w, d, h) => `${w} × ${d} × ${h} mm`,
  gBox: "Storage box",
  boxOn: "Add box + lid",
  trayCount: "Number of trays",
  partLabel: "Downloaded part",
  explode: "Explode",
  parts: {
    tray: "Tray",
    box: "Box",
    latch: "Latch",
    lid: "Lid",
  },
  boxNote: (wo, dd, hb, n) => `Box ${wo} × ${dd} × ${hb} mm · prints ${n} trays`,
  hwNote: (hinges) => `${HW.screw} mm nuts × ${hinges} · pin ${HW.pin} × ${HW.pinLen} mm × 1 (or 1.75 mm filament)`,
  bedWarnPart: (part, w, d) => `${part} prints ${w} × ${d} mm — larger than the print bed, it may not print in one piece`,
  tallWarn: (part, z) => `${part} is ${z} mm tall — beyond the print height of most printers`,
  problem: {
    "auto-squeezed": "No room left for automatic cells — reduce the cell sizes you set",
    "too-small": "Cells too small (they need at least twice the wall thickness)",
    overflow: "The sizes you set add up to more than the tray",
    "fractions-over": "The fractions add up to more than 1",
    "corner-clipped": "A corner cell is clipped by the corner radius — reduce the radius",
    "too-shallow": "The tray is too shallow — raise the height or reduce the wall thickness",
    "stack-wall": "Walls too thin for the locking rims — thicken the walls or reduce the clearance",
    "stack-shallow": "The tray is too shallow to stack — raise the height",
    "box-narrow": (doc) => `The box is too narrow for the hinges — the tray needs at least ${Math.round(boxDims(doc).minW * 10) / 10} mm, or reduce the corner radius`,
  },
  dlstl: "STL",
  copied: "Copied",
  fatal: "Could not load the calculator — try refreshing the page",
  unitMm: " mm",
  pct: (v) => `${v}%`,

  // ship 3 piece c: the template's static text, baked per language by the build (was hardcoded Thai)
  aboutP: "Design divided trays to organise drawers, desks and toolboxes. Set the size and the cells yourself, make the rims stackable, and download 3MF/STL files — free.",
};
export default S;
